"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EConstantType = void 0;
var EConstantType;
(function (EConstantType) {
    EConstantType["LOCATIONS"] = "general_locations";
    EConstantType["FILETYPES"] = "general_filetypes";
    EConstantType["VEHICLE_TYPES"] = "sales_car_types";
    EConstantType["VEHICLE_TYPES_EXTERNAL_USERS"] = "sales_car_types_external";
    EConstantType["LINK_ENTRY_MISSING_VEHICLES"] = "link_entry_api_missing_cars";
    EConstantType["LINK_ENTRY_ADMIN"] = "link_entry_api_missing_cars_admins";
    EConstantType["SURVEY_ENABLED"] = "survey_sending_enabled";
    EConstantType["SURVEY_SENDING_DAYS"] = "survey_sending_days";
    EConstantType["NOTIFICATIONS_PUSH_KEY"] = "notificationsPushServiceKey";
    // MOBILE_SELLER_DESCRIPTION = 'mobileSellerDescription',
    // MOBILE_SELLER_DESCRIPTION_RAW = 'mobileSellerDescriptionRaw',
    // MOBILE_SELLER_DESCRIPTION_FORMATTED = 'mobileSellerDescriptionFormatted',
    EConstantType["ONLINE_DESCRIPTION_RAW"] = "onlineDescriptionRaw";
    EConstantType["ONLINE_DESCRIPTION_FORMATTED"] = "onlineDescriptionFormatted";
    EConstantType["FINANCING_EXAMPLE_PERCENTAGE_UPFRONT"] = "sales_financing-percentage_upfront";
    EConstantType["FINANCING_EXAMPLE_PERCENTAGE_LAST_PAYMENT"] = "sales_financing-percentage_last_payment";
    EConstantType["FINANCING_EXAMPLE_MONTHS"] = "sales_financing-number_of_month";
    EConstantType["FINANCING_EXAMPLE_INTEREST_RATE"] = "sales_financing-interest_rate";
    EConstantType["SURVEYS_ENABLED"] = "survey_sending_enabled";
    EConstantType["SURVEYS_SENDNIG_DAYS"] = "survey_sending_days";
    EConstantType["VEHICLE_STATE_USAGE_TYPE"] = "vehicleStateUsageType";
    EConstantType["DATA_CHECK_MANDATORY"] = "dataCheckMandatory";
    EConstantType["LOCATION_SUBSIDIARY_ASSIGNMENT"] = "locationSubsidiaryAssignment";
    EConstantType["BANK_INFORMATION"] = "bankInformation";
    EConstantType["SUMMARIZE_NEW_CUSTOMERS"] = "summarizeNewCustomers";
    EConstantType["MAXIMUM_RESERVATION_DAYS"] = "maximimumReservationDays";
    EConstantType["TEMPLATE_DATA"] = "templateData";
    EConstantType["EDIT_SELLER"] = "editSeller";
    EConstantType["AVAILABILITY_NOTIFICATIONS"] = "availabilityNotifications";
    EConstantType["OFFER_MAIL_ATTACHEMENTS"] = "offerMailAttachements";
    EConstantType["LEAD_RECEIPENTS"] = "leadReceipents";
    EConstantType["LEAD_ESCALATION_HOURS"] = "leadEscalationHours";
    EConstantType["IMAGE_OVERLAY"] = "imageOverlay";
})(EConstantType = exports.EConstantType || (exports.EConstantType = {}));
;
